import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router'
import * as R from 'ramda'
import comments from 'selectors/search'

import LeftNav from 'material-ui/Drawer'
import LeftNavMenu from 'components/LeftNavMenu'

import ResultsList from './ResultsList'
import ActionBar from './ActionBar'

import actionBarActions from 'actions/actionbar'

let select = (state) => ({
	...state
  , comments: comments(state)
  , data: state.data
})
export class Search extends Component {
	constructor(props){
		super(props)
		this.state={
			results: []
		  , searchStr: ''
		}
	}
	render() {
			return(
				<div>
					<ActionBar
						navPanelIsOpened={this.props.actionBarReducers.leftNav}
						rightStackOpened={!!this.props.routeParams.id}
						filtersIsOpened={this.props.actionBarReducers.rightNav}
						handleToggleLeft={this.props.TOOGLE_LEFT_NAV}
						handleToggleFilters={this.props.TOOGLE_FILTERS_PANEL}
						count={this.state.results.length}
					/>
					<div className="flex-box">
						<ResultsList
							results={this.state.results}
							filtersIsOpened={this.props.actionBarReducers.rightNav}
							rightStackOpened={!!this.props.routeParams.id}
							navPanelIsOpened={this.props.actionBarReducers.leftNav}
							searchStr={this.state.searchStr}
							onSearchChange={(evt) => {
								this.setState({searchStr: evt.target.value})
								if(!evt.target.value.length || !evt.target.value.trim().length) {
									this.setState({results: []})
								}else{
									let acceptableIDs = R.values(
										R.map(
											doc => doc._id
										  , R.filter(
													(doc) =>(
														(doc.type == 'property')?
															!!~doc.alias.toLowerCase().indexOf(evt.target.value.toLowerCase())
															|| !!~doc.address.toLowerCase().indexOf(evt.target.value.toLowerCase())
															: (doc.type == 'tenant')?
																	!!~doc.firstName.toLowerCase().indexOf(evt.target.value.toLowerCase())
																	|| !!~doc.lastName.toLowerCase().indexOf(evt.target.value.toLowerCase())
																	|| !!~(doc.firstName + ' ' + doc.lastName).toLowerCase().indexOf(evt.target.value.toLowerCase())
																	: (doc.type == 'repairman')?
																			!!~doc.firstName.toLowerCase().indexOf(evt.target.value.toLowerCase())
																			: (doc.type == 'task')?
																					this.props.data[doc.propertyID] &&
																					(!!~this.props.data[doc.propertyID].alias.toLowerCase().indexOf(evt.target.value.toLowerCase())
																					|| !!~this.props.data[doc.propertyID].address.toLowerCase().indexOf(evt.target.value.toLowerCase()))

																				: false
													)
													, this.props.data
											)
										)
									)
									console.log(acceptableIDs)
									let res = R.filter(comment => R.any(accID => !!~comment.body.indexOf(accID), acceptableIDs), this.props.comments)
									console.log(res)
									this.setState({results: res})
								}

							}}
							searchString={this.state.searchStr}
							data={this.props.data}
							style={{
								width:
									(this.props.actionBarReducers.leftNav && !!this.props.routeParams.id)?
										"calc(50% - 115px)"
										: (!this.props.actionBarReducers.leftNav && !!this.props.routeParams.id)?
											"50%"
											: "auto"
							}}
						/>
					</div>
				</div>
			)
	}
}

export default connect(select, R.mergeAll([actionBarActions]))(Search)



// WEBPACK FOOTER //
// ./src/routes/manager/search/index.js